module.exports = __webpack_public_path__ + "static/media/techCharacteristics2.1a07b586.png";